module.exports = __webpack_public_path__ + "media/images/backgrounds/videokonf-zoom-7888a16e98274a0b033fedfa29fe7fd6.jpg";